import axios from "axios";
import { Message } from "element-ui";
import router from "@/router";
import NProgerss from "nprogress";
import "nprogress/nprogress.css";

import { adminLogout } from "@/api/login";

// 异常错误
const codeMessage = {
  402: "请求次数限制",
  403: "没有权限访问页面",
  404: "页面不存在",
  401: "跳转登录",
  500: "程序异常",
};
const service = axios.create({
  baseURL: "https://ydmxhapi.yundongm.cn:8099",
  timeout: 50000,
});
// 请求前拦截器
service.interceptors.request.use(
  (config) => {
    // 页面长时间无操作，自动退出到登录页
    var that = this;
    clearTimeout(top.window.login_out);
    if (top.window.location.hash != "#/login") {
      top.window.login_out = setTimeout(function () {
        const obj = {
          token: sessionStorage.getItem("token"),
        };
        adminLogout(obj).then(({ data: res }) => {
          console.log("res", res);
          if (res.result === 1) {
            that.$message({
              message: res.msg,
              type: "success",
              duration: "2000",
            });
          }
          sessionStorage.clear();
          that.$router.push("/login");
          top.window.location.reload();
        });
      }, 60 * 60 * 1000);
    }
    // config.headers['X-Requested-With'] = 'XMLHttpRequest'
    // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    config.headers["Content-Type"] =
      "application/x-www-form-urlencoded;charset=UTF-8";

    if (config.params) {
      config.params = {
        ...config.params,
        token: sessionStorage.getItem("token"),
      };
    }
    // console.log("config", config);

    // 请求头添加token
    NProgerss.start();
    const token = sessionStorage.getItem("token");
    // if (config.url !== 'admin/passport/login') {
    //   config.headers.Authorization = token
    // }
    if (token) {
      // config.headers.Authorization = token
      config.headers.Authorization = token;
      config.headers.token = token;

      // if (config.method == "get") {
      //   config.params = { ...config.params, token: token };
      // }
      // if (config.method == "post") {
      //   config.data = { ...config.data, token: token };
      // }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 请求后的拦截器
service.interceptors.response.use(
  (response) => {
    NProgerss.done();
    // 未登录
    if (response.data.result === -10) {
      const obj = {
        token: sessionStorage.getItem("token"),
      };

      adminLogout(obj).then(({ data: res }) => {
        sessionStorage.clear();
        window.location.href = "/#/login";
        window.location.reload();
      });
    }
    // 异常的处理
    // console.log('response位', response)
    // if (response.status === 200) {
    //   if (response.data)
    // }
    return response;
  },
  (error) => {
    console.log(error);
    console.warn("request error", error);
    const data = error.response;
    console.log("data", data);
    if (data.status === 401) {
      Message.error("请重新登陆");
      router.push("/login");
    }
    if (data) {
      const msg = codeMessage[data.status] || "未知错误";
      Message.error(msg);
      return Promise.reject(data);
    }
    return Promise.reject(error);
  }
);
export default service;
